import { defaultGetOptions, handle, defaultPostOptions } from "../../../custom_api/api_utils";
const moment = require("moment");
const apiBase = '/api/v1/reactions';
export const reactionsApi = (contentType, id)=>{
    const base = `${apiBase}/${contentType}/${id}`;
    return {
        getReactions: async ()=>{
            const reactions = await handle(await fetch(base, defaultGetOptions()));
            return reactions.kind === 'result' ? {
                ...reactions,
                value: {
                    ...reactions.value,
                    items: reactions.value.items.map((i)=>({
                            ...i,
                            date: moment(i.date)
                        }))
                }
            } : reactions;
        },
        postReaction: async (token, reaction)=>{
            const res = await fetch(base + `?token=${token}`, {
                body: JSON.stringify(reaction),
                ...defaultPostOptions()
            });
            if (400 <= res.status && res.status < 500) return {
                kind: 'unauthorized',
                status: res.status
            };
            if (res.status >= 500) return {
                kind: 'failed',
                status: res.status
            };
            return {
                kind: 'result',
                status: 200,
                value: {}
            };
        }
    };
};
